import React, { useState } from 'react';
import '../components/ServiceModal.css';

import Cctv from '../assets/cctvinstallation.png';
import Pc from '../assets/pcrepair.jpg';
import Web from '../assets/web.jpg';

const services = [
  {
    image: Cctv,
    title: 'CCTV Installation ',
    
    desc: 'Cameras, NVRs, remote monitoring and maintenance.',
    details: {
      long: "Secure your home or business with reliable, high-definition CCTV systems professionally installed and configured for 24/7 protection. We design surveillance setups tailored to your space, ensuring full coverage, clear visibility, and long-term performance.",
      points: [
        "Full site assessment & camera placement planning",
        "Professional installation of indoor & outdoor cameras",
        "NVR/DVR setup with recording optimization",
        "Remote monitoring for phone, tablet, and PC",
        "Motion detection & smart alert configuration",
        "Clean wiring & professional finishing",
        "Testing, training & long-term support"
      ]
    }
  },
  {
    image: Pc,
    title: 'Laptop & PC Repair',
    desc: 'Hardware diagnostics, replacement and software fixes.',
    details: {
      long: "Fast and reliable laptop and PC repair services for all brands and models. Whether it’s hardware failure or software issues, we diagnose the problem and provide cost-effective, long-lasting solutions.",
      points: [
        "Hardware diagnostics & performance testing",
        "SSD, RAM, battery & keyboard replacements",
        "Windows installation & system cleanup",
        "Virus removal & security hardening",
        "Cooling system service & thermal paste renewal",
        "Data backup & recovery options"
      ]
    }
  },
  {
    image: Web,
    title: 'Web Development',
    desc: 'Modern responsive websites, and hosting',
    details: {
      long: "We design and build modern, responsive websites tailored to your business needs. From sleek landing pages to full business websites, we deliver fast, secure and mobile-friendly solutions.",
      points: [
        "Responsive design for all devices",
        "Fast, secure, SEO-optimized websites",
        "Custom business pages & contact forms",
        "Website maintenance & updates",
        "Hosting setup and domain integration",
        "E-commerce options (optional)"
      ]
    }
  },
];

export default function Services() {

  const [selectedService, setSelectedService] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="container" style={{ paddingTop: 40, paddingBottom: 60 }}>
      
      <h2 className="section-title">Our Services</h2>

      <div className="services-wrapper">

        {/* DEFAULT GRID VIEW */}
        {!isExpanded && (
          <div className="services-page-grid">
            {services.map((s, i) => (
              <div 
                className="service-card" 
                key={i}
                onClick={() => {
                  setSelectedService(s);
                  setIsExpanded(true);
                }}
              >
                <div className="service-img-wrapper">
                  <img src={s.image} alt={s.title} />
                  <div className="learn-more-overlay">Learn More</div>

                </div>

                <div className="service-info">
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <span className="know-more">Click on the image to know more →</span>
                </div>

              </div>
            ))}
          </div>
        )}

        {/* EXPANDED SLIDING PANEL */}
        {isExpanded && selectedService && (
          <div className="service-details-panel slide-in">

            <div className="details-left">
              <img 
                src={selectedService.image} 
                alt={selectedService.title} 
                className="details-image" 
              />
            </div>

            <div className="details-right">
              <h2>{selectedService.title}</h2>
              <p>{selectedService.details.long}</p>

              <ul className="details-list">
                {selectedService.details.points.map((p, index) => (
                  <li key={index}>{p}</li>
                ))}
              </ul>

              <button 
                className="close-details" 
                onClick={() => setIsExpanded(false)}
              >
                Back
              </button>
            </div>

          </div>
        )}

      </div>
    </div>
  );
}
